export const noMessagesSlide = {
  iconBorder: "ui-icon-border-good",
  detail: "There are no messages for your contracts.",
};
